import { z } from "zod";
import { DbCreateInputOmit, nullishToOptional } from "../helpers";

export const PublishedDocPageVisitsEntry = z.object({
  id: z.string(),
  versionId: z.string(),
  pagePersistentId: z.string(),
  locale: z.string().optional(),
  timestamp: z.coerce.date(),
  visits: z.number(),
  userId: nullishToOptional(z.string()),
  anonymousId: nullishToOptional(z.string()),
});

export type PublishedDocPageVisitsEntry = z.infer<typeof PublishedDocPageVisitsEntry>;

export type CreatePublishedDocPageVisitsEntry = DbCreateInputOmit<PublishedDocPageVisitsEntry>;
